import request from "@/utils/request";
import axios from "axios";

// Main登录方法
export function login (data) {
    return request({
        url: '/auth/mainPlatform/login',
        headers: {
            isToken: false
        },
        method: 'post',
        data
    })
}

// Main获取企微登录信息接口
export function getWxInfo (data) {
    return request({
        url: '/auth/mainPlatform/getWXRedirectUri',
        headers: {
            isToken: false
        },
        method: 'post',
        data
    })
}

// Main登出方法
export function logoutMain (data) {
    return request({
        url: '/auth/mainPlatform/logout',
        headers: {
            isToken: false
        },
        method: 'delete',
        data
    })
}

// 是否校验登录接口(需要的是main平台登录接口。非若衣)
export function getInfo () {
    return axios.get(import.meta.env.VITE_APP_BASE_API + '/auth/mainPlatform/user/getInfo');
}

// 从企微扫码登录
export function loginMainByWX (data) {
    return request({
        url: `/auth/mainPlatform/loginFromWX?code=${data.code}`,
        headers: {
            isToken: false,
        },
        method: 'post',
        data,
    })
}

// 企微内嵌登录
export function loginWeComSidebar (data) {
    return request({
        url: `/auth/weComSidebar/loginWeComSidebar?code=${data.code}`,
        headers: {
            isToken: false,
        },
        method: 'post',
        data,
    })
}

// 修改密码
export function updatePwdApi (data) {
    return request({
        url: `/auth/mainPlatform/updatePwd`,
        method: 'post',
        data,
    })
}
